module.exports = __webpack_public_path__ + "static/media/PS.f003c9db.png";